import styled, { css } from "styled-components";
import { Body } from "@ddm-design-system/typography";

export const FieldValue = styled(Body)<{ disabled?: boolean }>(
  ({ theme, disabled }) => css`
    padding-top: ${theme.spaceUnit.xs};
    color: ${!disabled ? theme.colors.black : theme.colors.grey.grey50};
  `
);
